const routes = [{
  path: '/protocol',
  component: () => import('@/views/protocol'),
  name: 'protocol',
  meta: {
    title: '协议管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/product/protocol.js